import { jsx as r } from "react/jsx-runtime";
import { useGetLinkComponentAndProps as L } from "../../../hooks/link/index.js";
import P from "../../content/Icon/Icon.js";
import "styled-components";
import "react";
import "../../../ActionButton-B77eJAd5.js";
import "../../layout/Stack/Stack.js";
import "../../layout/Box/Box.js";
import "../../../index-CZ8zjHGv.js";
import h from "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
import "@material/material-color-utilities";
import "react-select";
import "react-select/async";
import "../../typography/Text/Text.js";
import "../../../context/Text.js";
import "../../../context/Typography.js";
import { sizeMap as x } from "../IconButton/consts.js";
import z from "../IconButton/hooks/useGetIconButtonStyles.js";
import "../Toggle/CustomCheckbox.js";
import "focus-trap-react";
import "../../content/Logo/consts.js";
function W({
  iconName: m,
  onClick: t,
  size: i = "large",
  to: p,
  newTab: n,
  tone: e = "primary",
  disabled: o = !1,
  replace: l,
  blend: s = !1,
  accessibilityLabel: c,
  state: f,
  fill: a = "filledTonal"
}) {
  const u = z({
    tone: e,
    disabled: o,
    blend: s,
    size: i,
    fill: a
  }), { Component: y, linkProps: k } = L({
    to: p,
    disabled: o,
    newTab: n,
    replace: l,
    state: f
  }), { iconSize: C } = x[i];
  return /* @__PURE__ */ r(
    y,
    {
      onClick: (I) => {
        !o && t && t(I);
      },
      "aria-label": c,
      disabled: o,
      ...u,
      ...k,
      children: /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(P, { accessibilityLabel: null, iconName: m, size: C }) })
    }
  );
}
export {
  W as default
};
